import * as React from "react";
import { Text, TokenTextAppearance } from "@volkswagen-onehub/components-core";
import { useQuery } from "@apollo/client";
import { gql } from "../../__generated__";
import { Link } from "../component/Link";
import { OmIntegratorConfig } from "../queries/integrator";
const omIntegrator = gql(OmIntegratorConfig);
export const AppsListView = () => {
    const { loading, data: integratorConfig } = useQuery(omIntegrator);
    if (loading || !integratorConfig) {
        return React.createElement("span", null, "loading...");
    }
    return (React.createElement("div", null,
        React.createElement(Text, { appearance: TokenTextAppearance.headline200, bold: true }, "Configured Feature Apps"),
        integratorConfig.omIntegratorConfig.featureAppConfigurations.map((featureApp) => (React.createElement("div", { key: featureApp.name },
            React.createElement(Link, { path: `/apps/${encodeURIComponent(featureApp.name)}`, text: featureApp.name }))))));
};
